import { D as e, w as t } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/utils/i18n-lite.js
var n = Symbol("i18n-lite"), r = Symbol("isPluralized"), i = /\{\{\s*(\w+)\s*}}/g, a = new class e {
	static #e = "fr";
	#t = e.#e;
	#n;
	#r = {};
	addTranslationsFromGlobResults(e) {
		for (let [t, n] of Object.entries(e)) {
			let e = t.match(/\/([^/]+)\.json$/)[1];
			this.addTranslations(e, n);
		}
	}
	addTranslations(e, t) {
		e in this.#r || (this.#r[e] = {}), Object.assign(this.#r[e], this.#i(t));
	}
	#i(e) {
		return typeof e != "object" || !e ? e : Array.isArray(e) ? e.map(this.#i, this) : Object.entries(e).reduce((e, [t, n]) => {
			let { key: i, pluralTag: a } = /^(?<key>.*?)(_(?<pluralTag>zero|one|two|few|many|other))?$/.exec(t).groups, o = this.#i(n);
			return a === void 0 ? {
				...e,
				[i]: o
			} : i in e ? (e[i][a] = o, e) : {
				...e,
				[i]: {
					[r]: !0,
					[a]: o
				}
			};
		}, {});
	}
	changeLanguage(e) {
		let { baseName: t, language: n } = new Intl.Locale(e), r = t === n, i = Object.keys(this.#r), a = i.filter((e) => e.includes("-")), o = i.filter((e) => !e.includes("-")), s = i.find((e) => e === t), c = o.find((e) => e === n) ?? a.find((e) => new Intl.Locale(e).language === n);
		if (s) {
			if (this.#t = s, r) return;
			this.#n = c;
		} else c && (this.#t = c, this.#n = void 0);
	}
	get language() {
		return this.#t;
	}
	get fallbackLocale() {
		return this.#n;
	}
	t(e, t) {
		return this.#a(e, t).split(i).reduce((e, n, r) => r % 2 == 0 ? e + n : e + t?.[n]);
	}
	#a(e, t) {
		let n = this.#o(e);
		return n[r] ? this.#s(n, t) : n;
	}
	#o(e) {
		let t = e.split("."), n = (e) => t.reduce((e, t) => e?.[t], this.#r[e]);
		return n(this.#t) ?? n(this.#n) ?? e;
	}
	#s(e, t) {
		return t?.count == null ? e.other : e[this.#c.select(t.count)] ?? e.other;
	}
	get #c() {
		return new Intl.PluralRules(this.#t);
	}
	install(e) {
		let r = (e, t) => this.t(e, t);
		e.config.globalProperties.$i18next = this, e.config.globalProperties.$t = r, e.provide(n, {
			i18next: this,
			t: r
		}), e.component("i18n", t({
			props: { t: {
				type: String,
				required: !0
			} },
			setup: (e, { slots: t }) => () => this.#a(e.t).split(i).reduce((e, n, r) => r % 2 == 0 ? [...e, n] : [...e, ...t[n]?.() ?? [`{{${n}}}`]], [])
		}));
	}
}();
function o() {
	return e(n);
}
//#endregion
export { o as n, a as t };
